/*
 * Component for the integrations tab on the settings page.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';

import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';
import { Grid, Typography } from '@mui/material';

import IntegrationTile from './IntegrationTile';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';


const abEnvironment = new AbEnvironment();
const SettingsIntegrationsQuery = graphql`
query SettingsIntegrationsQuery($accountId: UUID, $first: Int) {
  getappintegrationsforaccount(accountid: $accountId, first: $first) {
    totalCount
    nodes {
      appIntegrationId
      appName
      appDescription
      appLogo
      active
      accountDelegatedAuthsId
      appData
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  flex: {
    flex: 1,
  },
  appDiv: {
    marginTop: 8
  },
  appContainer:{
    float: 'left',
    marginRight: 20,
    maxWidth: 380,
    minWidth: 200,
    [theme.breakpoints.up('xs')]: {
      width: 'calc(100% - 16px)',
    },
    [theme.breakpoints.up('sm')]: {
      width: 380,
    },
  }
});

class SettingsIntegrations extends Component {
  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
    const { isAuthenticatedCustomer, isAuthenticatedReseller, isAuthenticatedVendor, logError } = this.props.auth;
    const classes = this.props.classes;

    let numberToShow = 50;

    let accountId = abEnvironment.getUserAttribute('a_id');

    // Integrations feature flags for various integrations
    let integrationsFB     = false;
    let integrationsQBO    = false;
    let integrationsXero   = false;
    let integrationsCustom = false;

    let integrationsRecurly = false;

    // Auth customer setup
    if (isAuthenticatedCustomer()) {
      let integrationsQboFlag = abEnvironment.getFlagValue("integrationsQBO");
      if (integrationsQboFlag != null && integrationsQboFlag.flagValue === 1)  { integrationsQBO = true; }
    }
    
    // Reseller setup
    if (isAuthenticatedReseller()) {
      let integrationsFbFlag = abEnvironment.getFlagValue("integrationsFB");
      if (integrationsFbFlag != null && integrationsFbFlag.flagValue === 1) { integrationsFB = true; }

      let integrationsQboFlag = abEnvironment.getFlagValue("integrationsQBO");
      if (integrationsQboFlag != null && integrationsQboFlag.flagValue === 1)  { integrationsQBO = true; }

      let integrationsXeroFlag = abEnvironment.getFlagValue("integrationsXero");
      if (integrationsXeroFlag != null && integrationsXeroFlag.flagValue === 1) { integrationsXero = true; }

      let integrationsCustomFlag = abEnvironment.getFlagValue("integrationsCustom");
      if (integrationsCustomFlag != null && integrationsCustomFlag.flagValue === 1) { integrationsCustom = true; }
    }

    // Vendor setup
    if (isAuthenticatedVendor()) {
      let integrationsRecurlyFlag = abEnvironment.getFlagValue("integrationsRecurly");
      if (integrationsRecurlyFlag != null && integrationsRecurlyFlag.flagValue === 1) { integrationsRecurly = true; }

      let integrationsCustomFlag = abEnvironment.getFlagValue("integrationsCustom");
      if (integrationsCustomFlag != null && integrationsCustomFlag.flagValue === 1) { integrationsCustom = true; }
    }

    return (
      <div className={classes.root}>

        <Grid container spacing={0} direction="row" justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h6">Configure integrations</Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2">AppBind has a growing number of built-in integrations to other systems, and an API that allows you to build your own custom integrations.</Typography>
          </Grid>
        </Grid>

        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={SettingsIntegrationsQuery}
          variables={{accountId: accountId, first: numberToShow}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              let thenodes = props.getappintegrationsforaccount.nodes;
              return (
                <div className={classes.appDiv} style={{clear:'right'}}>
                  {thenodes.map(n => {
                    // If the integration is already in use, it should be shown
                    if (n.accountDelegatedAuthsId != null ||
                        ( n.active > 0 && 
                          ( (n.appName === 'FreshBooks' && integrationsFB      === true) ||
                            (n.appName === 'QuickBooks' && integrationsQBO     === true) ||
                            (n.appName === 'Xero'       && integrationsXero    === true) ||
                            (n.appName === 'Recurly'    && integrationsRecurly === true) )   
                          ) 
                      ) 
                    {
                      return (
                        <div key={n.appIntegrationId} className={classes.appContainer}>
                          <IntegrationTile app={n} auth={this.props.auth} history={this.props.history}/>
                        </div>
                      );
                    }
                    return null;
                  })}

                  {integrationsCustom &&
                  <div key="custom" className={classes.appContainer}>
                    <IntegrationTile app="custom" auth={this.props.auth} history={this.props.history}/>
                  </div>}
                  <div style={{clear:'both'}}></div>
                </div>
              )
            }
            return (
              <div className={classes.appDiv}>
                <Typography>Loading...</Typography>
                <LoadingSpinner/>
              </div>
            );
          }}
        />
      </div>
    );
  }

}

export default withStyles(styleSheet)(SettingsIntegrations);
